import React, { useState } from 'react';
import './main-gallery.css';
import Modal from './modal';
import { galleryImages } from '../data/gallery-images.js';

const Gallery = () => {

  const [modal, setModal] = useState();
  const [numGroups, setNumGroups] = useState(1);
  const numImagesInGroup = 12;

  const showModal = (imageIndex, groupIndex) => {
    const lastImageIndex = (numGroups * numImagesInGroup) - 1;
    const absoluteIndex = (groupIndex * numImagesInGroup) + imageIndex;
    setModal(<Modal 
      startIndex = { absoluteIndex }
      imageItems = { galleryImages }
      onClose = { () => setModal(null) }
      lastImageIndex = { lastImageIndex }
      />);
  };

  return (
    <>
      {modal}
      <div className='galleryContainer'>
        <div className='innerContainer'>
          <h1>Our Projects</h1>
            <div>
              {Array.from({length: numGroups}, (_, groupIndex) => 
              {
                const start = groupIndex * numImagesInGroup;
                const end = start + numImagesInGroup;

                return <div className='gallery' key = {groupIndex}>
                  {galleryImages.slice(start, end).map((e, i) => 
                    <div 
                      className='imgBox'
                      key={i}
                      onClick={() => showModal(i, groupIndex)}
                    >
                      <img 
                        src={e.image} 
                        alt='Project images'
                      />
                    </div>
                  )}
                </div>
              })}
            </div>
            <button
              className='showMoreImage fontTwo'
              onClick={() =>
                (galleryImages.length < (numGroups + 1)*12) ? null : setNumGroups(numGroups + 1)
              }>
                Show More  <i className='fas fa-caret-down fontTwo'></i>
            </button>
        </div>
      </div>
    </>
  );
};

export default Gallery;